import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { CenteredModalTitle, VerticallyCentered } from "../../../../Constants/Constants";
import { CenteredModalSubTitle } from "../../../../Data/UiKits/Modal";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import CenterdModalBody from "./CenterdModalBody";

const CenteredModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={CenteredModalTitle} span={CenteredModalSubTitle} />
        <CardBody>
          <Btn color="success" onClick={toggle}>{VerticallyCentered}</Btn>
          <CenterdModalBody modal={modal} toggle={toggle} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default CenteredModal;
